import React from "react";
import { hooks } from "../hooks";
import { custom } from "../custom";
import { product } from "../product";
import { theme } from "../constants";
import { MAIN_URL } from "../config";

export const ProductCard = ({ item, isLast }) => {
  const navigate = hooks.useAppNavigate();
  const status = String(item?.product_status || "").toLowerCase();

  const isOutOfStock = status === "out of stock";
  const isInactive = status === "inactive";

  // ❌ Hide inactive products completely
  if (isInactive) return null;

  const renderImage = () => (
    <button
      onClick={() => navigate("/product", { state: { item } })}
      disabled={isOutOfStock}
      style={{
        borderRadius: 12,
        cursor: isOutOfStock ? "not-allowed" : "pointer",
        opacity: isOutOfStock ? 0.6 : 1,
        border: "none",
        background: "transparent",
        width: 100,
        height: "100%",
      }}
    >
      <custom.ImageBackground
        imageUrl={`${MAIN_URL}/${item?.item_image}`}
        style={{
          width: "100%",
          height: "100%",
          borderRadius: 12,
          backgroundColor: theme.colors.imageBackground,
          objectFit: "cover",
        }}
      />
    </button>
  );

  const renderInfo = () => (
    <div
      style={{
        flex: 1,
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        paddingLeft: 14,
      }}
    >
      {/* LEFT: Product Name + Price + Out of Stock Label */}
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <h6
          style={{
            ...theme.fonts.Mulish_400Regular,
            fontSize: 14,
            lineHeight: 1.5,
            margin: 0,
            color: theme.colors.textColor,
            fontWeight: 500,
            marginBottom: 4,
          }}
        >
          {item?.item_name}
        </h6>

        <product.ProductPrice
          item={item}
          containerStyle={{ marginBottom: 2 }}
        />

        {/* ⚠️ Out of Stock Label BELOW price */}
        {isOutOfStock && (
          <div
            style={{
              marginTop: 4,
              backgroundColor: "#FF4D4F",
              color: "#fff",
              padding: "2px 8px",
              borderRadius: 12,
              fontSize: 12,
              fontWeight: 600,
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              width: 90, // fixed width
              height: 24, // fixed height
              textAlign: "center",
            }}
          >
            Out of Stock
          </div>
        )}
      </div>

      {/* RIGHT: Product Counter */}
      <div
        style={{
          opacity: isOutOfStock ? 0.4 : 1,
          pointerEvents: isOutOfStock ? "none" : "auto",
        }}
      >
        <product.ProductCounter item={item} />
      </div>
    </div>
  );

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        height: 100,
        padding: "0 20px",
        marginBottom: isLast ? 20 : 14,
        paddingBottom: 14,
        borderBottom: `1px solid ${theme.colors.lavenderMist}`,
        opacity: isOutOfStock ? 0.9 : 1,
      }}
    >
      {renderImage()}
      {renderInfo()}
    </div>
  );
};
